import { render, staticRenderFns } from "./app-work-center.vue?vue&type=template&id=cc85aaae&scoped=true&"
import script from "./js/app-work-center.js?vue&type=script&lang=js&"
export * from "./js/app-work-center.js?vue&type=script&lang=js&"
import style0 from "./app-work-center.vue?vue&type=style&index=0&id=cc85aaae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc85aaae",
  null
  
)

export default component.exports